import Client from 'config/axios';
import posthog from 'posthog-js';

export interface IBodyLinked {
  token: string;
  followers: number;
  photo: string;
  uid: number;
  secret: string;
  verifier?: string;
  screenName: string;
  code?: string;
  facebookProfileUrl?: string;
  authenticationCode?: string;
  fanpageId?: string;
  isFanpage?: boolean;
}

export const postNetworkToken = async (
  token: string,
  tokenNetwork: IBodyLinked,
  network: string
) => {
  try {
    const response = await Client.post(
      `linked-social-network/${network}`,
      tokenNetwork,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    posthog.capture('LinkedSocialNetwork', {
      LinkedSocialNetwork: response,
      Network: network
    });

    return response;
  } catch (error: any) {
    throw {
      data: null,
      status: error?.response?.status ?? 500,
      errors: error?.response?.data.data ?? 'Error desconocido'
    };
  }
};

export const unlinkedNetwork = async (token: string, network: string) => {
  try {
    const { data } = await Client.delete(`unlinked-social-network/${network}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('UnlinkedNetwork', {
      UnlinkedNetwork: data,
      Network: network
    });
    return { data: data };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
